import React, { Component, Fragment } from 'react';
import { Container, Row, Col, Input, Label, Button, Form, FormGroup } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes, faCircle, faTrashAlt, faGripLines, faCopy, faSun } from '@fortawesome/free-solid-svg-icons'
import { faCircle as faCircleOutline } from '@fortawesome/free-regular-svg-icons'
import ReactDragListView from 'react-drag-listview'
import PermissionWrapper from '../../auth/PermissionWrapper';
import ConfirmButton from '../Modal/ConfirmButton';

class Workflows extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showDaily: true,
      showMonthly: true,
      showQuarterly: true,
      showAnnually: true,
      showUnset: true
    };
    this.scrollDivWorkflow = React.createRef();
  }

  standardRow = (workflow) => {
    this.props.info('Workflows.js/standardRow (workflow)', workflow);
    return (
      <Row className="adminRow pointer workflowRow" onClick={() => this.props.onEdit(workflow.id)}>
        <Col md={4} className="text-left">
          <FontAwesomeIcon icon={(workflow['active']) ? faCircle : faCircleOutline} className={"mr-3 " + ((workflow['active']) ? 'iconActive' : 'iconInactive')} />
          {workflow['name']}
          {workflow['morningProcess'] && <FontAwesomeIcon icon={faSun} className={"ml-2 text-warning"} />}
        </Col>
        <Col md={2}>
          {workflow.completionBusinessDays > 0 ? <>{workflow.completionBusinessDays} {(workflow.completionBusinessDays === 1 ? ' Bus. Day' : ' Bus. Days')}</> : <></>}
        </Col>
        <Col md={5} className="text-left">{workflow['description']}</Col>
        <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Reorder Workflows">
          <Col md={1} className="text-right" onMouseDown={() => this.props.setDragTarget(null)}>
            <span className="dragIcon p-2"><FontAwesomeIcon icon={faGripLines} /></span>
          </Col>
        </PermissionWrapper>
      </Row>
    )
  }

  editRow = (workflow) => {
    this.props.log('Workflows.js/editRow (workflow)', workflow);
    return (<>
      <Row key={"edit" + workflow.id} className="adminRow activeTab">
        <Col md={8} className="text-left">
          <Form inline>
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="Name"
                type="text"
                id={"edit-name" + workflow.id}
                name="name"
                value={this.props.isFieldNull(this.props.editWorkflow.name)}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="Description"
                type="text"
                id={"edit-description" + workflow.id}
                name="description"
                value={this.props.isFieldNull(this.props.editWorkflow.description)}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="Frequency"
                type="select"
                id="edit-duration"
                name="duration"
                value={this.props.isFieldNull(this.props.editWorkflow.duration)}
                onChange={e => this.props.onChange(e, 'edit')} >
                <option value="0">Select Frequency</option>
                <option value="24">Daily</option>
                <option value="730">Monthly</option>
                <option value="2190">Quarterly</option>
                <option value="8760">Annually</option>
              </Input>
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="Completion Bus. Days"
                type="number"
                id={"edit-completion-business-days" + workflow.id}
                name="completionBusinessDays"
                value={this.props.isFieldNull(this.props.editWorkflow.completionBusinessDays)}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="Time Target"
                type="number"
                id={"edit-time-target" + workflow.id}
                name="timeTarget"
                value={this.props.isFieldNull(this.props.editWorkflow.timeTarget)}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="pr-4 pb-2">
              <Input
                type="checkbox"
                id={"edit-morningProcess" + workflow.id}
                name="morningProcess"
                checked={this.props.isFieldNull(this.props.editWorkflow.morningProcess,true)}
                onChange={e => this.props.onChange(e, 'edit')} />
              <Label for={"edit-morningProcess" + workflow.id}>
                Morning Process
              </Label>
            </FormGroup>
            <FormGroup className="pr-4 pb-2">
              <Input
                type="checkbox"
                id={"edit-automated" + workflow.id}
                name="automated"
                checked={this.props.isFieldNull(this.props.editWorkflow.automated,true)}
                onChange={e => this.props.onChange(e, 'edit')} />
              <Label for={"edit-automated" + workflow.id}>
                Automated
              </Label>
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                type="checkbox"
                id={"edit-active" + workflow.id}
                name="active"
                checked={this.props.isFieldNull(this.props.editWorkflow.active,true)}
                onChange={e => this.props.onChange(e, 'edit')} />
              <Label for={"edit-active" + workflow.id}>
                Active
              </Label>
            </FormGroup>
          </Form>
        </Col>
        <Col md={4} className="text-right">
          <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Edit Workflows">
            <Button className="mx-1" color="success" onClick={this.props.handleEdit} title="Edit Workflow">
              <FontAwesomeIcon icon={faCheck} />
            </Button>
          </PermissionWrapper>
          <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Add Workflows">
            <Button className="mx-1" color="primary" onClick={() => { this.props.onCopy(workflow.id); window.scrollTo(0, this.scrollDivWorkflow.current.offsetTop); }} title="Copy Workflow">
              <FontAwesomeIcon icon={faCopy} />
            </Button>
          </PermissionWrapper>
          <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Delete Workflows">
            <ConfirmButton className="mx-3" color="danger" onClick={() => this.props.onDelete(workflow.id)}>
              <FontAwesomeIcon icon={faTrashAlt} />
            </ConfirmButton>
          </PermissionWrapper>
          <Button className="mx-1" color="secondary" onClick={this.props.handleCancel} title="Cancel">
            <FontAwesomeIcon icon={faTimes} />
          </Button>
        </Col>
        <Col md={2} className="text-right py-3 px-0">
          Workflow Tasks
        </Col>
        <Col md={4} className="text-left py-3 maxHpanel">
          <ReactDragListView {...this.props.dragProps}>
            {this.props.workflowTasks.findIndex(workflowTask => parseInt(workflowTask.duration) === parseInt(this.props.editWorkflow.duration)) > -1 ?
              [...this.props.workflowTasks].map(workflowTask => {
                const thisWorkflowTasks = this.props.editWorkflow.workflowTasks;
                const newOrder = (thisWorkflowTasks.findIndex(item => item.id === workflowTask.id) > -1) ?
                  thisWorkflowTasks[thisWorkflowTasks.findIndex(item => item.id === workflowTask.id)].order : workflowTask.order * 100000;
                return ({
                  ...workflowTask,
                  order: newOrder
                })
              }).filter(workflowTask => parseInt(workflowTask.duration) === parseInt(this.props.editWorkflow.duration))
                .sort((a, b) => a.order - b.order)
                .map(workflowTask => (
                  <Row className="workflowRow" key={workflowTask.id}>
                    <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Reorder Workflows">
                      {this.props.editWorkflow.workflowTasks.findIndex(i => i.id === parseInt(workflowTask.id)) > -1 ?
                        <Col md={2} className="text-right" onMouseDown={() => this.props.setDragTarget(workflow.id)}>
                          <span className="dragIcon p-2"><FontAwesomeIcon icon={faGripLines} /></span>
                        </Col> :
                        <Col md={2}></Col>}
                    </PermissionWrapper>
                    <Col md={10}>
                      <Label key={workflowTask.id} for={"workflowTask_" + workflowTask.id}>
                        <Input
                          type="checkbox"
                          name="workflowTasks"
                          id={"workflowTask_" + workflowTask.id}
                          checked={this.props.isFieldNull(this.props.editWorkflow.workflowTasks.findIndex(i => i.id === parseInt(workflowTask.id)) > -1,true)}
                          onChange={e => this.props.onChange(e, 'edit')}
                        />{workflowTask.name}
                        {parseInt(workflowTask.completionBusinessDays) !== 0 && workflowTask.completionBusinessDays > 0 ?
                          (workflowTask.completionBusinessDays === 1 ? <span className="timerLine"> ({workflowTask.completionBusinessDays} Bus. Day)</span> : <span className="timerLine"> ({workflowTask.completionBusinessDays} Bus. Days)</span>)
                          : <></>}
                      </Label>
                    </Col>
                  </Row>
                )) : <>No workflow tasks for the selected frequency</>}
          </ReactDragListView>
        </Col>
        <Col md={2} className="text-right py-3 px-0">
          Clients
        </Col>
        <Col md={4} className="text-left p-3 pl-5 maxHpanel">
          {[...this.props.clients]
            .map(client => (
              <Row key={client.id}>
                <Label for={"workflowClient_" + client.id}>
                  <Input
                    type="checkbox"
                    name="workflowClients"
                    id={"workflowClient_" + client.id}
                    checked={this.props.isFieldNull(this.props.editWorkflow.workflowClients.findIndex(i => i.id === parseInt(client.id)) > -1,true)}
                    onChange={e => this.props.onChange(e, 'edit')}
                  />{client.client}
                </Label>
              </Row>
            ))}
        </Col>
      </Row>
    </>
    )
  }

  addRow = () => {
    this.props.info('Workflows.js/addRow');
    return (
      <Row className="py-4 text-left align-items-bottom ">
        <Col>
          <Form inline>
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="New Workflow Name"
                type="text"
                id="workflow-add"
                name="name"
                value={this.props.isFieldNull(this.props.newWorkflow.name)}
                onChange={e => this.props.onChange(e)} />
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="Description"
                type="text"
                id="workflow-add-description"
                name="description"
                value={this.props.isFieldNull(this.props.newWorkflow.description)}
                onChange={e => this.props.onChange(e)} />
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="Frequency"
                type="select"
                id="workflow-add-duration"
                name="duration"
                value={this.props.isFieldNull(this.props.newWorkflow.duration)}
                onChange={e => this.props.onChange(e)} >
                <option value="0">Select Frequency</option>
                <option value="24">Daily</option>
                <option value="730">Monthly</option>
                <option value="2190">Quarterly</option>
                <option value="8760">Annually</option>
              </Input>
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="Completion Bus. Days"
                type="number"
                id="workflow-add-completion-business-days"
                name="completionBusinessDays"
                value={this.props.isFieldNull(this.props.newWorkflow.completionBusinessDays)}
                onChange={e => this.props.onChange(e)} />
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="Time Target"
                type="number"
                id={"workflow-time-target"}
                name="timeTarget"
                value={this.props.isFieldNull(this.props.newWorkflow.timeTarget)}
                onChange={e => this.props.onChange(e)} />
            </FormGroup>
            <FormGroup className="pr-4 pb-2">
              <Input
                type="checkbox"
                id={"workflow-morningProcess"}
                name="morningProcess"
                checked={this.props.isFieldNull(this.props.newWorkflow.morningProcess,true)}
                onChange={e => this.props.onChange(e)} />
              <Label for={"workflow-morningProcess"}>
                Morning Process
              </Label>
            </FormGroup>
            <FormGroup className="pr-4 pb-2">
              <Input
                type="checkbox"
                id={"workflow-automated"}
                name="automated"
                checked={this.props.isFieldNull(this.props.newWorkflow.automated,true)}
                onChange={e => this.props.onChange(e)} />
              <Label for={"workflow-automated"}>
                Automated
              </Label>
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                type="checkbox"
                id={"workflow-active"}
                name="active"
                checked={this.props.isFieldNull(this.props.newWorkflow.active,true)}
                onChange={e => this.props.onChange(e)} />
              <Label for={"workflow-active"}>
                Active
              </Label>
            </FormGroup>
            
          </Form>
        </Col>
        <Col md={3} className="text-right">
          <Button
            disabled={this.props.newWorkflow.name === ''}
            color="primary"
            onClick={this.props.handleAdd}
          >Add Workflow</Button>
        </Col>
      </Row>
    )
  }

  render() {
    this.props.info('Workflows.js/render');
    return (
      <Container className="adminContainer" fluid>
        <Row className="text-left adminRow font-weight-bold">
          {this.props.workflows.findIndex(workflow => workflow.duration === 24) > -1 ?
            <Col md={2} className="px-4">
              <Label><Input
                type="checkbox"
                name="showDaily"
                checked={this.props.isFieldNull(this.state.showDaily,true)}
                onChange={() => this.setState({
                  showDaily: !this.state.showDaily
                })}
              /> Daily</Label>
            </Col> : <></>}
          {this.props.workflows.findIndex(workflow => workflow.duration === 730) > -1 ?
            <Col md={2} className="px-4">
              <Label><Input
                type="checkbox"
                name="showMonthly"
                checked={this.props.isFieldNull(this.state.showMonthly,true)}
                onChange={() => this.setState({
                  showMonthly: !this.state.showMonthly
                })}
              /> Monthly</Label>
            </Col> : <></>}
          {this.props.workflows.findIndex(workflow => workflow.duration === 2190) > -1 ?
            <Col md={2} className="px-4">
              <Label><Input
                type="checkbox"
                name="showQuarterly"
                checked={this.props.isFieldNull(this.state.showQuarterly,true)}
                onChange={() => this.setState({
                  showQuarterly: !this.state.showQuarterly
                })}
              /> Quarterly</Label>
            </Col> : <></>}
          {this.props.workflows.findIndex(workflow => workflow.duration === 8760) > -1 ?
            <Col md={2} className="px-4">
              <Label><Input
                type="checkbox"
                name="showAnnually"
                checked={this.props.isFieldNull(this.state.showAnnually,true)}
                onChange={() => this.setState({
                  showAnnually: !this.state.showAnnually
                })}
              /> Annually</Label>
            </Col> : <></>}
          {this.props.workflows.findIndex(workflow => (workflow.duration == null || workflow.duration === 0)) > -1 ?
            <Col md={2} className="px-4">
              <Label><Input
                type="checkbox"
                name="showUnset"
                checked={this.props.isFieldNull(this.state.showUnset,true)}
                onChange={() => this.setState({
                  showUnset: !this.state.showUnset
                })}
              /> Unset</Label>
            </Col> : <></>}
        </Row>
        <ReactDragListView {...this.props.dragProps}>
          {this.props.workflows.filter(workflow => (this.state.showDaily && workflow.duration === 24)
            || (this.state.showMonthly && workflow.duration === 730)
            || (this.state.showQuarterly && workflow.duration === 2190)
            || (this.state.showAnnually && workflow.duration === 8760)
            || (this.state.showUnset && (workflow.duration == null || workflow.duration === 0))
          ).map(workflow => (
            <Fragment key={workflow.id}>{this.props.editWorkflow.id === workflow.id ? this.editRow(workflow) : this.standardRow(workflow)}</Fragment>
          ))}
          <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Add Workflows">
            <div><div className="scrollDiv" ref={this.scrollDivWorkflow}></div>{this.addRow()}</div>
          </PermissionWrapper>
        </ReactDragListView>
      </Container>
    );

  }
}

export default Workflows;
